
export function lowerCaseCompare(term1: string, term2: string) {
    if (term1 && term2) {
        return term1.toLocaleLowerCase() === term2.toLocaleLowerCase();
    }
    return false;
}
